import React, { useState, useRef, useEffect } from 'react';
import { TextField, Menu, MenuItem, FormControl, InputLabel, IconButton, InputAdornment } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import { getStringOperators } from '../../list.functions';
import { useTranslation } from 'react-i18next';

const StringFilter = ({ item, applyValue, onFilterOperatorChange }) => {
    const [operator, setOperator] = useState(item?.operator || 'equals');
    const [value, setValue] = useState(item?.value || '');
    const [focused, setFocused] = useState(false);
    const [preventBlur, setPreventBlur] = useState(false);
    const { t } = useTranslation();
    const operatorList = getStringOperators(t)

    const inputRef = useRef(null);

    const handleKeyDown = (event) => {
        event.target.focus();
        setPreventBlur(true);
        //console.info('handleKeyDown', event, focused);
    }

    const handleFocus = (event) => {
        setFocused(true);
        //console.info('handleFocus', event, focused);
    }

    const handleBlur = (event) => {
        if (preventBlur) {
            event.target.focus();
            setPreventBlur(false);
        } else {
            setFocused(false);
        }

        //console.info('handleBlur', event, focused);
    }

    const handleValueChange = (event) => {
        const newValue = event.target.value;
        //console.info('handleValueChange', newValue)
        setValue(newValue);
        if (operator !== 'isEmpty' && operator !== 'isNotEmpty') {
            applyValue({ ...item, operator, value: newValue });
        }
        setFocused(true)
    };

    const handleValueEmpty = () => {
        //console.info('handleValueEmpty')
        setValue('');
        applyValue({ ...item, value: '', operator: item?.operator })
    };

    const isValueInputDisabled = operator === 'isEmpty' || operator === 'isNotEmpty';
    const isValueEmpty = value === '' || value === null || value === undefined;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        //console.info('handleOpen')
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        //console.info('handleOpen')
        setAnchorEl(null);
    };

    const handleOperatorChange = (operator) => {
        setOperator(operator);

        if (onFilterOperatorChange) {
            onFilterOperatorChange(operator);
        }

        if (operator === 'isEmpty' || operator === 'isNotEmpty') {
            applyValue({ ...item, operator: operator, value: ' ' });
        } else if (value) {
            applyValue({ ...item, operator: operator, value: value });
        }

        handleClose();
    };

    // useEffect(() => {
    //     console.info('STATO FOCUSED', focused)
    // }, [focused])

    return (
        <FormControl variant="standard" size="small" className='mtska-list-filter-wrapper'>
            <InputLabel shrink={focused || !isValueEmpty}>{t(operator)}</InputLabel>

            <TextField
                variant="standard"
                size="small"
                className="mtska-list-filter-value"
                value={value}
                onChange={handleValueChange}
                inputRef={inputRef}
                disabled={isValueInputDisabled}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                InputProps={!isValueEmpty && {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                sx={{ padding: '4px' }}
                                onClick={() => handleValueEmpty()}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />

            <IconButton
                size="small"
                onClick={handleOpen}
            >
                <FilterListIcon fontSize="small" />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {(operatorList ?? []).map((operator) => (
                    <MenuItem
                        key={operator.value}
                        value={operator.value}
                        onClick={() => handleOperatorChange(operator.value)}
                    >
                        {operator.label}
                    </MenuItem>
                ))}
            </Menu>
        </FormControl>
    );
};

export default StringFilter;